/* eslint-disable react/prop-types */
import { VisuallyHidden } from '@leagueplatform/genesis-commons';
import {
  Icon,
  GDSIconProps,
  Box,
  TextAction,
  GDSStyleObject,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { LocalesKey } from 'common/types';
import pdfIcon from 'assets/pdf-icon.svg';

export interface LinkComponentProps {
  text: LocalesKey;
  url?: string;
  linkProps?: GDSStyleObject;
  icon?: GDSIconProps['icon'];
  isPDFlINK?: boolean;
  target?: string;
}

export const LinkComponent = ({
  text,
  url,
  linkProps,
  icon,
  isPDFlINK,
  target,
}: LinkComponentProps) => {
  const { formatMessage } = useIntl();

  return (
    <TextAction
      href={url}
      target={target}
      color="interactive.action.subdued"
      css={{
        textAlign: 'left',
        fontSize: '$bodyTwo',
        color: '$interactiveActionSubdued',
        fontWeight: 'normal',
        ...linkProps,
      }}
    >
      <Box as="span" css={{ display: 'inline-flex', alignItems: 'center' }}>
        {formatMessage({ id: text })}
        {icon && <Icon icon={icon} css={{ marginLeft: '$half' }} size="$one" />}
        {isPDFlINK && (
          <img
            src={pdfIcon}
            alt="PDF"
            style={{
              marginLeft: '6px',
              flexShrink: 0,
              width: '16px',
              height: '16px',
            }}
          />
        )}
        {target === '_blank' && (
          <VisuallyHidden data-testid="new-tab-msg">
            {formatMessage({ id: 'STR_OPENS_IN_A_NEW_TAB' })}
          </VisuallyHidden>
        )}
      </Box>
    </TextAction>
  );
};
